'use client';

import PropertyReviewsList from '@/components/elements/Reviews/PropertyReviewsList';
import ReviewDetailsModal from '@/components/elements/Reviews/ReviewDetailsModal';

import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Review } from './PropertyReviewsList';

export default function PropertyReviewsSection({
  summary,
  reviews,
}: {
  summary: { overallRating: number; totalReviews: number };
  reviews: Review[];
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const displayedReviews = reviews.slice(0, 3); // Show only first 3 reviews

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-start justify-between text-md lg:text-xl">
          <div className="flex items-start gap-2">
            <span>Rating</span>
          </div>
          <div className="flex flex-col items-end">
            <span className="text-xl font-bold">{summary.overallRating.toFixed(1)}</span>
            <span className="text-muted-foreground text-sm">({summary.totalReviews}) reviews</span>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {reviews.length === 0 && (
          <div className="flex justify-center items-center h-full">
            <p className="text-muted-foreground">No reviews yet</p>
          </div>
        )}

        {/* Recent reviews */}
        {displayedReviews.map((review) => (
          <PropertyReviewsList.Review key={review.id} review={review} />
        ))}

        {/* Show more button */}
        {reviews.length > 0 && (
          <div className="flex justify-end">
            <Button variant="link" onClick={() => setIsModalOpen(true)}>
              View all reviews
            </Button>
          </div>
        )}

        {/* Modal for all reviews */}
        <ReviewDetailsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          summary={summary}
          reviews={reviews}
        />
      </CardContent>
    </Card>
  );
}
